"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmRequestStatus = exports.LlmRequestType = exports.LlmTrigger = void 0;
var LlmTrigger;
(function (LlmTrigger) {
    LlmTrigger["manualRetry"] = "manualRetry";
    LlmTrigger["automatedRetry"] = "automatedRetry";
    LlmTrigger["dimensionCompletion"] = "dimensionCompletion";
    LlmTrigger["premiumPurchase"] = "premiumPurchase";
    LlmTrigger["manualRegenerate"] = "manualRegenerate";
})(LlmTrigger = exports.LlmTrigger || (exports.LlmTrigger = {}));
var LlmRequestType;
(function (LlmRequestType) {
    LlmRequestType["nutshell"] = "nutshell";
    LlmRequestType["loveReport"] = "loveReport";
    LlmRequestType["snippets"] = "snippets";
    LlmRequestType["therapistReport"] = "therapistReport";
    LlmRequestType["careerReport"] = "careerReport";
})(LlmRequestType = exports.LlmRequestType || (exports.LlmRequestType = {}));
var LlmRequestStatus;
(function (LlmRequestStatus) {
    LlmRequestStatus["created"] = "created";
    LlmRequestStatus["processing"] = "processing";
    LlmRequestStatus["complete"] = "complete";
    LlmRequestStatus["failed"] = "failed";
    LlmRequestStatus["retried"] = "retried";
})(LlmRequestStatus = exports.LlmRequestStatus || (exports.LlmRequestStatus = {}));
